import React, {FC} from 'react';
import styles from './SidePanel.module.scss';
import {FAQ} from './FAQ';
import {SupportContact} from './SupportContact';
import {FAQItem} from '../../types';
import {cn} from '../../../../../../utils';
import {faqItems as defaultFAQItems} from './FAQ/faqItems';

interface SidePanelProps {
  faqItems?: FAQItem[];
  className?: string;
}

const SidePanel: FC<SidePanelProps> = ({ 
  faqItems = defaultFAQItems,
  className 
}) => {
  return (
    <aside className={cn(styles.sidePanel, className)}>
      <FAQ items={faqItems} />
      <SupportContact />
    </aside>
  );
};

export default SidePanel;

